import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../../api.js';
import { useAuth } from '../../auth/AuthProvider.js';
import type { ConfigStatus } from '../../types/onboarding.js';

export function Timezone() {
  const { activeOrgId } = useAuth();
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ['config-status', activeOrgId],
    queryFn: () => api<ConfigStatus>(`/orgs/${activeOrgId}/config-status`),
    enabled: !!activeOrgId,
  });
  const [tz, setTz] = useState('UTC');

  useEffect(() => {
    if (data?.organization.timezone) setTz(data.organization.timezone);
  }, [data?.organization.timezone]);

  const submit = useMutation({
    mutationFn: () =>
      api(`/orgs/${activeOrgId}/config`, {
        method: 'PATCH',
        body: JSON.stringify({ timezone: tz }),
      }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['config-status'] });
      nav('/app/onboarding/wizard/logo');
    },
  });

  // biome-ignore lint/suspicious/noExplicitAny: Intl.supportedValuesOf is recent
  const tzList = ((Intl as any).supportedValuesOf?.('timeZone') ?? []) as string[];

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium">Zona horaria</h2>
      <p className="text-sm text-slate-600">
        Selecciona la zona horaria para tu organización. Puedes cambiarla luego en configuración.
      </p>
      <select
        value={tz}
        onChange={(e) => setTz(e.target.value)}
        className="w-full rounded border px-3 py-2"
      >
        {tzList.map((z) => (
          <option key={z} value={z}>
            {z}
          </option>
        ))}
      </select>
      <div className="flex justify-end gap-3 pt-2">
        <button
          type="button"
          onClick={() => nav('/app/onboarding/wizard/logo')}
          className="text-sm text-slate-600"
        >
          Saltar →
        </button>
        <button
          type="button"
          disabled={submit.isPending}
          onClick={() => submit.mutate()}
          className="rounded bg-blue-600 px-4 py-2 text-white disabled:opacity-50"
        >
          Guardar y continuar →
        </button>
      </div>
    </div>
  );
}
